import React, { useCallback, useMemo } from 'react';

import { KYCBanner } from '@atlas/components';
import {
  isUserNeedBankAccountNumbers,
  isUserNeedKyc,
  NotificationManager,
  useApplicationState,
} from '@atlas/core';
import { BasePopup, Button, Icon, Label } from '@atlas/ui';

import PartialVerificationButton from 'components/Verification/PartialVerificationButton';
import VerificationButton from 'components/Verification/VerificationButton';

const defaultModalText = {
  btnText: 'go_to_kyc',
  description: 'kyc_verification_description',
  title: 'kyc_popup_title',
};

const VerificationPopup = ({ data, id }) => {
  const { account } = useApplicationState();

  const modalText = useMemo(() => {
    if (isUserNeedKyc(account)) {
      return defaultModalText;
    }

    if (isUserNeedBankAccountNumbers(account)) {
      return {
        btnText: 'kyc_popup_register_bank_account_button',
        description: 'kyc_popup_register_bank_account_descriprion',
        title: 'kyc_popup_register_bank_account_title',
      };
    }

    return defaultModalText;
  }, [account]);

  const handleClose = useCallback(() => NotificationManager.removeNotification(id), [id]);

  return (
    <BasePopup className="kyc-verification__popup" onClose={handleClose}>
      <Button className="kyc-verification__popup-close" onClick={handleClose}>
        <Icon name="close" />
      </Button>
      <KYCBanner
        button={
          data?.isPartialRegulation ? (
            <PartialVerificationButton onClick={handleClose} />
          ) : (
            <VerificationButton label={modalText.btnText} onClick={handleClose} />
          )
        }
        className="kyc-popup"
        description={
          <Label className="kyc-verification__popup-description" message={modalText.description} />
        }
        icon={
          <Icon
            className="kyc-verification__popup-icon"
            height={32}
            name="security-legitimuz"
            width={32}
          />
        }
        layout="vertical"
        title={<Label className="kyc-verification__popup-title" message={modalText.title} />}
      />
    </BasePopup>
  );
};

export default VerificationPopup;
